var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      model: {
        value: _vm.isFormValid,
        callback: function($$v) {
          _vm.isFormValid = $$v
        },
        expression: "isFormValid"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "mb-12 pt-2 float-remover", attrs: { color: "white" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "start" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  attrs: { cols: "5", sm: "5", md: "3" }
                },
                [
                  _c("label", { staticClass: "font-weight-light" }, [
                    _vm._v("Cantidad de vehículos")
                  ])
                ]
              ),
              _c(
                "v-col",
                { attrs: { cols: "3", sm: "6", md: "4" } },
                [
                  _c(
                    "v-radio-group",
                    {
                      attrs: {
                        rules: [_vm.rules.allowedValues([0, 1, 2])],
                        row: _vm.$vuetify.breakpoint.smAndUp ? true : false
                      },
                      on: { mouseup: _vm.numberOfCarsChanged },
                      model: {
                        value: _vm.numberOfCars,
                        callback: function($$v) {
                          _vm.numberOfCars = $$v
                        },
                        expression: "numberOfCars"
                      }
                    },
                    [
                      _c("v-radio", {
                        attrs: { label: "Ninguno", value: 0, color: "#60BB46" }
                      }),
                      _c("v-radio", {
                        attrs: { label: "1", value: 1, color: "#60BB46" }
                      }),
                      _c("v-radio", {
                        attrs: { label: "2", value: 2, color: "#60BB46" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-scroll-y-transition",
            { attrs: { group: "" } },
            _vm._l(_vm.numberOfCars, function(n, index) {
              return _c(
                "v-row",
                { key: n },
                [
                  _c(
                    "v-col",
                    [
                      _c("Access-Car", {
                        ref: "Car",
                        refInFor: true,
                        attrs: {
                          oldAccessCar: _vm.oldAccessCars[index],
                          index: index,
                          numberPlateForValidation:
                            index == 0 ? _vm.getNumberPlate : ""
                        },
                        on: { validateNumberPlate: _vm.validateNumberPlate }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _c("Form-Navigation-Buttons", {
        on: {
          previousStep: _vm.previousStep,
          validateStep: _vm.validateStep,
          reset: function($event) {
            return _vm.$router.push({ name: "tickets" })
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }